import clsx from 'clsx';
import React, { type PropsWithChildren } from 'react';

import { Tooltip } from '../../Tooltip/Tooltip';

type PrimaryButtonV3Props = {
  onClick: VoidFunction;
  className?: string;
  disabled?: boolean;
  disabledTooltipText?: string;
  'data-testid'?: string;
};
export const PrimaryButtonV3 = ({
  children,
  onClick,
  className,
  disabled = false,
  disabledTooltipText,
  'data-testid': testId,
}: PropsWithChildren<PrimaryButtonV3Props>) => (
  <Tooltip
    tooltipComponent={<span className="text-main">{disabledTooltipText}</span>}
    tooltipDisabled={!disabled || !disabledTooltipText}
    placement="top-start"
    delayShow={500}
    delayHide={500}
    baseComponent={
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        data-testid={testId}
        className={clsx(
          'flex items-center justify-center',
          'h-f4 px-fone-half',
          'font-FragmentMono text-md uppercase',
          disabled
            ? 'bg-main-200 text-main-500 hover:cursor-not-allowed'
            : 'bg-main text-negative hover:bg-negative hover:text-main hover:cursor-pointer',
          'transition-colors',
          className
        )}
      >
        {children}
      </button>
    }
  />
);
